import { render, staticRenderFns } from "./StatementView.vue?vue&type=template&id=3c8ccc12&scoped=true"
import script from "./StatementView.vue?vue&type=script&lang=js"
export * from "./StatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ccc12",
  null
  
)

export default component.exports